import type {Component} from 'grapesjs';
import type {PrimaryConfigOptions} from '../index';

interface InputFieldProps {
  type: string;
  property: string;
  component?: Component;
  label?: string;
  placeholder?: string;
  labelClass?: string;
  containerClass?: string;
  inputClass?: string;
  inputContainerClass?: string;
  icon?: string;
  cb?: (component: Component | null, value: string, event: Event) => void;
  eventType?: string;
}

export default (opt: PrimaryConfigOptions): void => {
  const {editor} = opt;
  const styleManager = editor.StyleManager;

  styleManager.addType('pmw-input-field', {
    create(data: any): HTMLDivElement {
      const props = data.props as InputFieldProps;
      props.component = props.component ?? editor.getSelected();
      props.placeholder = props.placeholder ?? '';
      props.labelClass = props.labelClass ?? '';
      props.containerClass = props.containerClass ?? '';
      props.inputClass = props.inputClass ?? '';
      props.inputContainerClass = props.inputContainerClass ?? '';
      props.label = props.label ?? '';
      props.icon = props.icon ?? '';
      props.eventType = props.eventType ?? 'change';

      const container = document.createElement('div');
      const label = document.createElement('label');
      const span = document.createElement('span');
      const input = document.createElement('input');
      const icon = document.createElement('i');

      container.className = `${props.type} input-field-container ${props.containerClass}`;
      label.className = `field-label body-xs ${props.labelClass}`;
      label.htmlFor = `input-field`;
      input.className = `field-input body-xs ${props.inputClass} js-field-input-${props.property}`;
      input.id = `input-field`;
      input.value = props.component?.get(props.property) ?? '';
      input.placeholder = props.placeholder;
      icon.className = `icon size-icon-20 icon-${props.icon}`;
      span.className = `field-input-container ${props.inputContainerClass}`;

      if (props.label) {
        label.append(props.label);
        container.append(label);
      }

      span.append(input);

      if (props.icon) {
        span.append(icon);
      }

      container.append(span);

      input.addEventListener(props.eventType, (event: Event): void => {
        const target = event.target as HTMLInputElement;
        const inputVal = target.value.trim();

        props.component?.set(props.property, inputVal);
        if (typeof props.cb === 'function') {
          props.cb(props.component ?? null, inputVal, event);
        }
      });

      return container;
    },
    
    emit(): void {
      // Empty emit method
    },

    update(): void {
      // Empty update method
    }
  });
};